import { render, staticRenderFns } from "./Patient-data.vue?vue&type=template&id=33dbb381"
import script from "./Patient-data.js?vue&type=script&lang=js&external"
export * from "./Patient-data.js?vue&type=script&lang=js&external"
import style0 from "./Patient-data.vue?vue&type=style&index=0&id=33dbb381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports